// extracted by mini-css-extract-plugin
export default {"roomOverview":"roomsList_roomOverview__chAh+","roomWraper":"roomsList_roomWraper__Kx6sT","roomLinkInfo":"roomsList_roomLinkInfo__MqbEs"};